import {
  Col,
  InputInteger,
  Panel,
  Row,
  SectionTitle
} from '@elotech/components';
import { Label } from 'common/components';
import { FormikProps } from 'formik';
import { FC } from 'react';

import { ProcessoDigitalSelect } from './components/processo-digital/ProcessoDigitalSelect';

type Props = Pick<FormikProps<any>, 'values' | 'setFieldValue'> & {
  isProcessoDigital: boolean;
  disabled?: boolean;
};

export const ProtocoloNumeracaoSection: FC<Props> = ({
  values,
  setFieldValue,
  isProcessoDigital,
  disabled
}) => (
  <>
    <SectionTitle>{isProcessoDigital ? 'Processo' : 'Protocolo'}</SectionTitle>
    <Row>
      {isProcessoDigital ? (
        <Col md={6}>
          <Panel title="Processo Digital">
            <ProcessoDigitalSelect
              value={values.protocoloId}
              onChange={(value: string) => setFieldValue('protocoloId', value)}
            />
          </Panel>
        </Col>
      ) : (
        <>
          <Col md={3}>
            <Label>Número Processo</Label>
            <input
              value={values.numeroProtocolo}
              name="numeroProtocolo"
              disabled={disabled}
              onChange={event =>
                setFieldValue('numeroProtocolo', event.target!.value)
              }
            />
          </Col>
          <Col md={3}>
            <Label>Ano Processo</Label>
            <InputInteger
              name="anoProtocolo"
              value={values.anoProtocolo}
              disabled={disabled}
              onChange={event =>
                setFieldValue('anoProtocolo', event.target!.value)
              }
            />
          </Col>
        </>
      )}
    </Row>
  </>
);

export default ProtocoloNumeracaoSection;
